<template>
  <v-container class="py-2 px-1">
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">{{ title }}</v-toolbar-title>
    </v-toolbar>
    <div v-if="loading" class="spacing-top">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </div>
    <div v-else class="spacing-top">
      <v-card class="custom-font-regular">
        <v-card-title class="ml-4 title-font-size custom-font-semi-bold">
          <v-icon class="mr-3">far fa-file-alt</v-icon>
          Datos Generales del Expediente
          <template v-if="caseFile.hasOwnProperty('permissions') && showActionButtons">
            <v-spacer></v-spacer>
            <ExpedienteDetailCardActionButton :permissions="caseFile.permissions" :user="caseFile.user"
                                              @update="emitUpdate"></ExpedienteDetailCardActionButton>
          </template>
          <template v-if="pdfURL && pdfURL.length">
            <v-spacer></v-spacer>
            <v-btn color="primary" small :href="pdfURL" target="_blank">Descargar en PDF</v-btn>
          </template>
        </v-card-title>
        <v-divider class="mx-4"></v-divider>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-layout text-xs-left wrap px-3 pt-3 :pb-3="$vuetify.breakpoint.mdAndUp">
              <v-flex tag="strong" xs6 sm5 md4 lg3 text-xs-left pl-4 mb-1>Número:</v-flex>
              <v-flex xs6 sm6 md8 lg9>{{ caseFile.code }}</v-flex>
              <v-flex tag="strong" xs6 sm5 md4 lg3 text-xs-left pl-4 mb-1>Apertura:</v-flex>
              <v-flex xs6 sm6 md8 lg9>{{ caseFile.date }}</v-flex>
              <v-flex tag="strong" xs6 sm5 md4 lg3 text-xs-left pl-4 mb-1>Juez:</v-flex>
              <v-flex xs6 sm6 md8 lg9>{{ userName }}</v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6>
            <v-layout text-xs-left wrap px-3 pb-3 :pt-3="$vuetify.breakpoint.mdAndUp">
              <v-flex tag="strong" xs6 sm5 md4 lg3 text-xs-left pl-4 mb-1>Parte/s:</v-flex>
              <v-flex xs6 sm6 md8 lg9>{{ clubName }} {{ thirdClubName }}</v-flex>
              <v-flex tag="strong" xs6 sm5 md4 lg3 text-xs-left pl-4 mb-1>Etapa:</v-flex>
              <v-flex xs6 sm6 md8 lg9>{{ caseFile.status }}</v-flex>
              <v-flex tag="strong" xs6 sm5 md4 lg3 text-xs-left pl-4 mb-1>Asignación:</v-flex>
              <v-flex xs6 sm6 md8 lg9>{{ caseFile.assignee }}</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <template v-if="caseFile.match || caseFile.matchStadium || caseFile.matchDate">
          <v-divider class="mx-4"></v-divider>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-layout text-xs-left wrap px-3 pt-3 :pb-3="$vuetify.breakpoint.mdAndUp">
                <v-flex tag="strong" xs6 sm5 md4 lg3 text-xs-left pl-4 mb-1>Partido:</v-flex>
                <v-flex xs6 sm6 md8 lg9>{{ caseFile.match }}</v-flex>
                <v-flex tag="strong" xs6 sm5 md4 lg3 text-xs-left pl-4 mb-1>Estadio:</v-flex>
                <v-flex xs6 sm6 md8 lg9>{{ caseFile.matchStadium }}</v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md6>
              <v-layout text-xs-left wrap px-3 pb-3 :pt-3="$vuetify.breakpoint.mdAndUp">
                <v-flex tag="strong" xs6 sm5 md4 lg3 text-xs-left pl-4 mb-1>Fecha de partido:</v-flex>
                <v-flex xs6 sm6 md8 lg9>{{ caseFile.matchDate }}</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </template>
      </v-card>
      <slot></slot>
    </div>
  </v-container>
</template>

<script>
import ExpedienteDetailCardActionButton from './ExpedienteDetailCardActionButton'

export default {
  props: {
    loading: Boolean,
    caseFile: Object,
    title: {
      type: String,
      default: 'Expediente'
    },
    showActionButtons: Boolean,
    judge: Object,
    pdfURL: String
  },

  components: {
    ExpedienteDetailCardActionButton
  },

  computed: {
    userName () {
      let user = this.judge
      if (!user || !user.lastName || !user.firstName) return ''
      return `${user.lastName}, ${user.firstName}`
    },
    clubName () {
      let club = this.caseFile.club
      return (club) ? club.nombre : ''
    },
    thirdClubName () {
      let thirdClub = this.caseFile.thirdClub
      return (thirdClub) ? `- ${thirdClub.nombre}` : ''
    }
  },

  methods: {
    emitUpdate (caseFile) {
      this.$emit('update', caseFile)
    }
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em !important;
}
.title-font-size {
  font-size: 1.2em;
}
</style>
